// @vue/component
export default {
  name: "DashboardPlaceholder",
};
